// This file is auto-generated by `podium codegen`. Do not edit.
//
// Lookup-type registry derived from `x-lookup` vendor extensions on named
// OpenAPI schemas. One entry per lookup type — keyed by schema name
// (which matches the codegen'd TS type from `@hey-api/openapi-ts`).
//
// Shape is asserted against `LookupSpec` by @podium/platform/lookups.
// See docs/rfcs/0004-lookup-types.md.

export const LOOKUPS = {
  UserRef: { kind: 'remote', endpoint: "/api/users", operationId: "user_list", valueField: "id", labelField: "displayName", searchParam: "search" },
} as const

export type LookupTypeName = 'UserRef'
